'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var vk_bridgeApiRequest_index = require('./bridgeApiRequest/index.js');
var vk_bridgeGetAccessToken_index = require('./bridgeGetAccessToken/index.js');
var vk_bridgeGetAccessTokenAndSave_index = require('./bridgeGetAccessTokenAndSave/index.js');
var vk_bridgeStatEvent_index = require('./bridgeStatEvent/index.js');
var vk_getAppId_index = require('./getAppId/index.js');
var vk_getAppPlatform_index = require('./getAppPlatform/index.js');
var vk_prepareUtm_index = require('./prepareUtm/index.js');
var vk_randomizeRequestId_index = require('./randomizeRequestId/index.js');
var vk_vkStat_index = require('./vkStat/index.js');
require('@vkontakte/vk-bridge');
require('../locals/STATS/index.js');
require('../locals/setVkAccessToken/index.js');
require('../googleGtm/googleGtmEvent/index.js');



exports.bridgeApiRequest = vk_bridgeApiRequest_index;
exports.bridgeGetAccessToken = vk_bridgeGetAccessToken_index;
exports.bridgeGetAccessTokenAndSave = vk_bridgeGetAccessTokenAndSave_index;
exports.bridgeStatEvent = vk_bridgeStatEvent_index;
exports.getAppId = vk_getAppId_index;
exports.getAppPlatform = vk_getAppPlatform_index;
exports.prepareUtm = vk_prepareUtm_index;
exports.randomizeRequestId = vk_randomizeRequestId_index;
exports.vkStat = vk_vkStat_index;
